interface IJobCorpsCenter {
    id?: number;
    name?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    addressCity?: string | null;
    addressState?: string | null;
    addressZip?: number | null;
    addressCountry?: string | null;
    altAddressLine1?: string | null;
    altAddressLine2?: string | null;
    altAddressCity?: string | null;
    altAddressState?: string | null;
    altAddressZip?: number | null;
    altAddressCountry?: string | null;
    phoneNumber?: number | string | null;
    fax?: number | string | null;
    fieldCoordinator?: string[] | null;
    instructors?: string[] | null;
    leadInstructors?: string[] | null;
    active?: boolean | null;
    reactivated?: Date | null;
    reactivatedByUserId?: number | null;
    deactivated?: Date | null;
    deactivatedByUserId?: number | null;
}

class JobCorpsCenter implements IJobCorpsCenter {
    public id?: number;
    public name?: string | null;
    public addressLine1?: string | null;
    public addressLine2?: string | null;
    public addressCity?: string | null;
    public addressState?: string | null;
    public addressZip?: number | null;
    public addressCountry?: string | null;
    public altAddressLine1?: string | null;
    public altAddressLine2?: string | null;
    public altAddressCity?: string | null;
    public altAddressState?: string | null;
    public altAddressZip?: number | null;
    public altAddressCountry?: string | null;
    public phoneNumber?: number | string | null;
    public fax?: number | string | null;
    public fieldCoordinator?: string[] | null;
    public instructors?: string[] | null;
    public leadInstructors?: string[] | null;
    public active?: boolean | null;
    public reactivated?: Date | null;
    public reactivatedByUserId?: number | null;
    public deactivated?: Date | null;
    public deactivatedByUserId?: number | null;

    constructor(c: IJobCorpsCenter = {}) {
        this.id = c.id;
        this.name = c.name !== undefined ? c.name : null;
        this.active = c.active !== undefined ? c.active : null;
        this.addressLine1 = c.addressLine1 !== undefined ? c.addressLine1 : null;
        this.addressLine2 = c.addressLine2 !== undefined ? c.addressLine2 : null;
        this.addressState = c.addressState !== undefined ? c.addressState : null;
        this.addressCity = c.addressCity !== undefined ? c.addressCity : null;
        this.addressZip = c.addressZip !== undefined ? c.addressZip : null;
        this.addressCountry = c.addressCountry !== undefined ? c.addressCountry : null;
        this.altAddressLine1 = c.altAddressLine1 !== undefined ? c.altAddressLine1 : null;
        this.altAddressLine2 = c.altAddressLine2 !== undefined ? c.altAddressLine2 : null;
        this.altAddressState = c.altAddressState !== undefined ? c.altAddressState : null;
        this.altAddressCity = c.altAddressCity !== undefined ? c.altAddressCity : null;
        this.altAddressZip = c.altAddressZip !== undefined ? c.altAddressZip : null;
        this.altAddressCountry = c.altAddressCountry !== undefined ? c.altAddressCountry : null;
        this.phoneNumber = c.phoneNumber !== undefined ? c.phoneNumber : null;
        this.fax = c.fax !== undefined ? c.fax : null;
        this.fieldCoordinator = c.fieldCoordinator !== undefined ? c.fieldCoordinator : null;
        this.instructors = c.instructors !== undefined ? c.instructors : null;
        this.leadInstructors = c.leadInstructors !== undefined ? c.leadInstructors : null;
        this.reactivated = c.reactivated !== undefined ? c.reactivated : null;
        this.reactivatedByUserId = c.reactivatedByUserId !== undefined ? c.reactivatedByUserId : null;
        this.deactivated = c.deactivated !== undefined ? c.deactivated : null;
        this.deactivatedByUserId = c.deactivatedByUserId !== undefined ? c.deactivatedByUserId : null;
    }

    public addressString(): string {
        return this.formatAddress(
            this.addressLine1,
            this.addressCity,
            this.addressState,
            this.addressZip,
            this.addressCountry);
    }

    public altAddressString(): string {
        return this.formatAddress(
            this.altAddressLine1,
            this.altAddressCity,
            this.altAddressState,
            this.altAddressZip,
            this.altAddressCountry);
    }

    public formatAddress(
        addressLine1?: string | null,
        addressCity?: string | null,
        addressState?: string | null,
        addressZip?: string | number | null,
        addressCountry?: string | null): string {
        return `${addressLine1 ? addressLine1 : ''} `
        + `\n${addressCity ? addressCity : ''}, ${addressState ? addressState : ''} `
        + `${addressZip ? addressZip : ''}${addressCountry ? ', ' + addressCountry : ''}`;
    }
}

export default JobCorpsCenter;
export {JobCorpsCenter, IJobCorpsCenter};
